/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_DescriptionInputs */

const en_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description provided.`)
};

const id_no_description = /** @type {(inputs: No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada deskripsi yang diberikan.`)
};

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const es_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const fr_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const de_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const ja_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const zh_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const ar_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const it_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const ru_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const pt_no_description = en_no_description;

/** @type {(inputs: No_DescriptionInputs) => LocalizedString} */
const ko_no_description = en_no_description;

/**
* | output |
* | --- |
* | "No description provided." |
*
* @param {No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_description = /** @type {((inputs?: No_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_description(inputs)
	if (locale === "es") return es_no_description(inputs)
	if (locale === "fr") return fr_no_description(inputs)
	if (locale === "de") return de_no_description(inputs)
	if (locale === "ja") return ja_no_description(inputs)
	if (locale === "zh") return zh_no_description(inputs)
	if (locale === "ar") return ar_no_description(inputs)
	if (locale === "id") return id_no_description(inputs)
	if (locale === "it") return it_no_description(inputs)
	if (locale === "ru") return ru_no_description(inputs)
	if (locale === "pt") return pt_no_description(inputs)
	return ko_no_description(inputs)
});